export const ko = {
  app: {
    name: "ARGOS",
    title: "통합 관제 시스템",
    subtitle: "4드론 + 2휴머노이드 군집 자율 임무",
    footer: "ACC v0.1.0 · Apache-2.0 · 대구 강북소방서 민발",
  },
  nav: {
    command: "지휘 관제",
    dashboard: "대시보드",
    cop: "COP",
    missions: "임무",
    robots: "로봇",
    alerts: "알람",
    audit: "감사",
    twofa: "2FA",
    logout: "로그아웃",
  },
  role: {
    commander: "지휘관",
    vice: "부지휘관",
    controller: "관제사",
    sim: "시뮬",
    admin: "관리자",
  },
  login: {
    username: "사용자 ID",
    password: "비밀번호",
    submit: "로그인",
    submitting: "로그인 중...",
    failed: "로그인 실패",
    twofa_title: "2단계 인증",
    twofa_hint: "인증 앱 6자리 코드 또는 백업 코드(8자) 입력",
    twofa_placeholder: "123456 또는 ABCD1234",
    twofa_submit: "인증 완료",
    twofa_submitting: "인증 중...",
    twofa_back: "← 다시 로그인",
    twofa_failed: "OTP 인증 실패",
  },
  common: {
    loading: "로딩 중…",
    error: "오류",
    retry: "다시 시도",
    cancel: "취소",
    save: "저장",
    delete: "삭제",
    confirm: "확인",
    none: "—",
  },
  status: {
    pending: "대기",
    running: "실행",
    paused: "일시정지",
    completed: "완료",
    aborted: "중단",
    error: "오류",
  },
  severity: {
    critical: "치명",
    high: "높음",
    medium: "주의",
    low: "정보",
  },
  dashboard: {
    drones_count: "드론 (군집)",
    humanoids: "휴머노이드",
    active_alerts: "활성 알람",
    no_drones: "등록된 드론 없음. 관리자에게 문의.",
    recent_alerts: "최근 알람 (실시간 WebSocket)",
    no_alerts: "알람 없음",
    operations_3d: "3D 작전 화면 (실시간 WebSocket)",
    controls_help: "마우스 드래그: 회전 · 휠: 줌 · 우클릭 드래그: 패닝",
    fire_legend: "화재 카테고리 레전드 (K-class)",
    fire_legend_general: "A · 일반 (목재·종이) · 물·포말 진압",
    fire_legend_oil: "B · 유류 (휘발유·기름) · 포말·CO2 (물 금지)",
    fire_legend_electrical: "C · 전기 (배전반·전선) · CO2·분말 (물 금지)",
    fire_legend_metal: "D · 금속 (마그네슘·티타늄) · 특수 분말 (D-class)",
    fire_legend_gas: "E · 가스 (LPG·도시가스) · 차단 우선 + 냉각",
    fire_count_active: "활성 화재 (카테고리별)",
    drone_capable: "드론 진압 가능",
    humanoid_capable: "휴머노이드 진압 가능",
    sim2real_title: "Sim2Real 갭 (시뮬 vs 실 위치 차)",
    sim2real_no_data: "데이터 없음 — 시뮬 실행 + 실 telemetry 필요",
    sim2real_n_pairs: "매칭 쌍",
    sim2real_mean: "평균 거리 (m)",
    sim2real_p50: "중앙값 (m)",
    sim2real_p95: "p95 (m)",
    sim2real_max: "최대 (m)",
    sim2real_by_robot: "로봇별 갭",
    sim2real_warning: "임계 1m 초과 — 시뮬 신뢰도 낮음",
    sim2real_ok: "임계 1m 이내 — 시뮬 신뢰",
    sim2real_all_missions: "전체 합산",
    sim2real_select_mission: "Mission 선택",
    chaos_title: "카오스 시뮬 통계",
    mission_state_title: "임무 상태 (오케스트레이터)",
    mission_state_unavailable: "ROS 미연결 또는 임무 미시작 — rosbridge 연결 대기 중",
    mission_state_robots: "활성 로봇",
    mission_state_fires: "활성 화점",
    mission_state_victims: "감지 피해자",
    mission_state_critical_unassigned: "위급 임무 미할당 {{count}}건",
    mission_state_critical_hint: "수행 가능 로봇 부재 — 증원 또는 수동 파견 검토 필요",
    mission_state_age: "{{age}}초 전",
    mission_state_stale: "⚠ {{age}}초 경과 — stale 가능",
    mission_state_not_converged: "CBBA 할당 비수렴 — 배정이 차선일 수 있음",
    victim_board_title: "요구조자 현황판 (#142)",
    victim_board_unavailable: "ROS 미연결 또는 미수신 — rosbridge 연결 대기 중",
    victim_board_count: "식별 {{identified}}명 + 미식별 {{unidentified}}건",
    victim_board_empty: "감지된 요구조자 없음",
    victim_board_unidentified: "미식별",
    victim_board_priority: "우선 {{p}}",
    victim_board_age: "{{age}}초 전",
    victim_board_stale: "⚠ {{age}}초 경과 — stale 가능",
    chaos_no_events: "카오스 이벤트 없음",
    chaos_disables: "다운 발생",
    chaos_revives: "자동 복구",
    chaos_currently_down: "현재 다운",
    chaos_mean_downtime: "평균 다운타임",
    chaos_max_downtime: "최대 다운타임",
    chaos_by_robot: "로봇별",
    chaos_currently_disabled: "다운 중",
    dispatch_stats_title: "운영자 진압 명령 통계",
    dispatch_total: "총 명령",
    dispatch_last_24h: "최근 24시간",
    dispatch_by_user: "운영자별",
    dispatch_by_category: "카테고리별",
    dispatch_no_events: "진압 명령 기록 없음",
    mission_stats_title: "임무 누적 통계",
    mission_total: "총 임무",
    mission_completion: "완료율",
    mission_avg_duration: "평균 소요",
    mission_last_24h: "24h 시작",
    mission_no_data: "임무 기록 없음",
    dispatch_history_title: "최근 진압 명령 이력",
    dispatch_history_empty: "명령 이력 없음",
    dispatch_history_count: "최근 {{n}}건",
    health_title: "운영 readiness",
    health_status_ok: "정상",
    health_status_warning: "주의",
    health_status_critical: "위험",
    health_chaos_active: "카오스 다운",
    health_sim2real_gap: "Sim2Real 갭",
    health_running_missions: "진행 임무",
    health_offline_robots: "오프라인 로봇",
  },
  missions: {
    title: "임무",
    title_count: "임무 ({{count}})",
    new: "새 임무",
    none: "임무 없음. 우상단 새 임무 클릭.",
    col_name: "이름",
    col_status: "상태",
    col_env: "환경",
    col_started: "시작",
    col_control: "제어",
    btn_start: "시작",
    btn_pause: "일시정지",
    btn_resume: "재개",
    btn_abort: "중단",
    btn_replay: "Replay",
    create_title: "새 임무 생성",
    name_label: "임무 이름",
    name_placeholder: "예: 2층 사무실 화재 진압 #1",
    mode_label: "생성 방식",
    mode_sim: "무작위 시나리오 + 즉시 시뮬",
    mode_manual: "수동",
    n_drones: "드론 수",
    n_humanoids: "휴머노이드 수",
    create_failed: "임무 생성 실패",
    create_btn: "생성",
    creating: "생성 중…",
    abort_title: "임무 강제 중단",
    abort_desc: "\"{{name}}\" 임무를 중단하면 모든 로봇이 즉시 자동 귀환합니다. 진행 중인 자율 정책이 무력화됩니다.",
    benchmark_label: "A/B 비교 실행 (cbba vs random)",
    benchmark_help: "에피소드 수 (3~20, 0=비활성)",
    benchmark_result: "A/B 비교 결과",
    benchmark_winner: "승자",
    benchmark_cbba: "cbba 평균 보상",
    benchmark_random: "random 평균 보상",
    benchmark_delta: "성공률 차이",
  },
  replay: {
    loading: "Replay 로딩 중…",
    load_failed: "Replay 로드 실패",
    title: "Replay",
    back_to_missions: "← 임무 목록",
    duration_summary: "{{seconds}}초 · {{points}} 텔레메트리 · {{alerts}} 알람 · 임무 {{percent}}% 완료",
    download_aar: "AAR 다운로드",
    tab_replay: "Replay",
    tab_aar: "AAR 보고서",
    engage_events_title: "진압 이벤트 (시간순)",
    stat_telemetry: "총 텔레메트리",
    stat_alerts: "알람",
    stat_assignments: "임무 완료",
    stat_completion: "완료율",
    stat_engage: "진압 이벤트",
  },
  dispatch: {
    title: "진압 명령 — 화재 #{{id}}",
    category: "카테고리",
    location: "위치",
    severity: "심각도",
    recommended: "권장 로봇",
    candidates: "후보 ({{n}}대)",
    no_capable: "진압 가능 로봇 없음",
    confirm: "진압 명령 발송",
    cancel: "취소",
    dispatching: "발송 중…",
    dispatched: "발송 완료",
    failed: "명령 발송 실패",
    distance: "거리 {{m}}m",
    no_position: "위치 미수신",
  },
  alerts_page: {
    realtime: "● 실시간",
    no_alerts: "알람 없음",
    resolved: "해결됨",
    acknowledged: "확인됨",
    unack: "미확인",
  },
  twofa: {
    title: "2단계 인증 (TOTP)",
    enabled: "활성화됨",
    disabled: "비활성화",
    backup_remaining: "백업 코드 잔량",
    setup_recommend: "admin·commander 권한은 활성화 강력 권장",
    start_setup: "2FA 설정 시작",
    qr_title: "QR 코드 스캔",
    qr_hint: "Google Authenticator·1Password·Authy 등 인증 앱으로 아래 QR 을 스캔하고 6자리 코드를 입력하세요.",
    secret_label: "수동 입력용 secret",
    code_placeholder: "6자리 코드",
    enable: "확인 + 활성화",
    backup_title: "백업 코드 (안전한 곳에 보관 — 1회만 표시)",
    backup_hint: "인증 앱 분실 시 백업 코드 1건으로 로그인 가능합니다. 사용 후 폐기됩니다.",
    backup_done: "보관 완료 — 닫기",
    manage_title: "관리",
    manage_placeholder: "현재 6자리 코드 또는 백업 코드",
    btn_regen: "백업 코드 재발급",
    btn_disable: "2FA 비활성화",
    setup_failed: "setup 실패",
    verify_failed: "verify 실패",
    disable_failed: "disable 실패",
    regen_failed: "재발급 실패",
  },
};

export type Translations = typeof ko;
